module.exports = __webpack_public_path__ + "img/icade.a3735f72.jpg";